import { useEffect, useState } from 'react'
import moment from 'moment'
import { getFilterConfing } from './history__filter.config'
import { IItem } from '../__filterList/history__filterList'
import { IUser } from '../../../core/models/Users'

export interface ISelectedFilter {
    id: string
    name: string
    checked?: boolean
}

type Date = {
    startDate?: string
    endDate?: string
}

type FilterField = {
    id: string
    name: string
    index: number
    checked?: boolean
}

const HistoryFilterMethods = (p_: any) => {
    const [isFilterOpen, setIsFilterOpen] = useState<boolean>(false)
    const [selectedFilter, setSelectedFilter] = useState<any>(null)
    const [filterFields, setFilterFields] = useState<FilterField[]>([])
    const [_filterSearch, setFilterSearch] = useState<string>('')
    const [selected, setSelected] = useState<any>({})
    const [startDate, setStartDate] = useState<string>(moment().format())
    const [endDate, setEndDate] = useState<string>(moment().add(1, 'day').format())
    const [resetRequested, setResetRequested] = useState<boolean>(false)

    useEffect(() => {
        setSelected(p_.selected)
    }, [p_.selected])

    const filterSearch = (filterSearch: string) => {
        setFilterSearch(filterSearch)
    }

    const openFilter = () => {
        const appliedFilter = getFilterConfing().filtersBy.find(({ id }) => {
            if (id === 'date') return !!(p_.selected.startDate || p_.selected.endDate)

            return !!p_.selected[id]?.length
        })

        setIsFilterOpen(true)
        setSelected(p_.selected)
        setResetRequested(false)

        if (appliedFilter) {
            selectFilter(appliedFilter, p_.selected)
        } else {
            setSelectedFilter(null)
            setFilterFields([])
            setFilterSearch('')
        }
    }

    const closeFilter = () => {
        setIsFilterOpen(false)
    }

    const dateSelectFilter = (selectedFilter: ISelectedFilter, selectedFilters = selected) => {
        if (selectedFilter.id === 'date') {
            const days: Date = {}
            let byStartDateChecked = false
            let byEndDateChecked = false

            if (selectedFilters.startDate) {
                days.startDate = moment().format(selectedFilters.startDate)
                byStartDateChecked = true
            }
            if (selectedFilters.endDate) {
                days.endDate = moment().format(selectedFilters.endDate)
                byEndDateChecked = true
            }

            p_.setByEndDateChecked(byEndDateChecked)
            p_.setByStartDateChecked(byStartDateChecked)

            if (days.startDate) {
                setStartDate(days.startDate)
            }
            if (days.endDate) {
                setStartDate(days.endDate)
            }
        }
    }

    const selectFilter = (selectedFilter: ISelectedFilter, selectedFilters = selected) => {
        setSelectedFilter(selectedFilter)
        setFilterFields([])
        setFilterSearch('')
        setResetRequested(false)

        const filterFields: FilterField[] = []
        dateSelectFilter(selectedFilter, selectedFilters)

        if (!p_.data[selectedFilter.id]) {
            return
        }

        p_.data[selectedFilter.id].forEach((item: any, index: number) => {
            const field: FilterField = {
                id: item,
                name: item.email ? item.email : item,
                index,
            }

            if (getFilterConfing()[`${selectedFilter.id}Fields`]) {
                let name = item
                const findedName = getFilterConfing()[`${selectedFilter.id}Fields`].find((field: ISelectedFilter) => {
                    return field.id === item
                })

                if (findedName) {
                    name = findedName.name
                }

                field.name = name
            }

            if (selectedFilters && selectedFilters[selectedFilter.id]) {
                if (selectedFilter.id === 'userId') {
                    const id = field.id

                    if (selectedFilters[selectedFilter.id].includes(id)) {
                        field.checked = true
                    }
                } else {
                    if (selectedFilters[selectedFilter.id].includes(field.id)) {
                        field.checked = true
                    }
                }
            }
            filterFields.push(field)
        })

        setFilterFields(filterFields)
    }
    const checkAll = (checked: boolean) => {
        let _filterFields = [...filterFields]

        _filterFields.forEach((field: FilterField) => (field.checked = checked))

        setSelectedMethod(selected, selectedFilter, filterFields)

        setFilterFields(_filterFields)
    }

    const toggleField = (index: number) => {
        const _filterFields = [...filterFields]

        filterFields[index].checked = !filterFields[index].checked

        setSelectedMethod(selected, selectedFilter, _filterFields)
        setFilterFields(_filterFields)
    }
    const setSelectedMethod = (selected: IItem, selectedFilter: ISelectedFilter, filterFields: ISelectedFilter[]) => {
        const newSelected = { ...selected }
        newSelected[selectedFilter.id] = filterFields.filter((field) => field.checked).map((field) => field.id)
        setSelected({
            ...newSelected,
        })
    }
    const resetFilter = () => {
        setSelected({})
        setSelectedFilter(null)
        setFilterFields((currentFields) =>
            currentFields.map((field) => ({
                ...field,
                checked: false,
            }))
        )
        p_.setByStartDateChecked(false)
        p_.setByEndDateChecked(false)
        setResetRequested(true)
    }
    const onFilterChange = () => {
        if (resetRequested) {
            closeFilter()

            if (p_.onFilterChange) {
                p_.onFilterChange({}, true)
            }

            return
        }

        if (!selectedFilter) return

        let filter = { ...selected }

        if (selectedFilter.id !== 'date') {
            delete filter.startDate
            delete filter.endDate
        }

        for (let key in filter) {
            if (filter.hasOwnProperty(key)) {
                if (key !== selectedFilter.id) {
                    delete filter[key]

                    continue
                }
                if (key === 'userId') {
                    const usersId = filter[key].map((user: IUser) => user.id)
                    filter['userId'] = usersId.join('//')
                } else {
                    filter[key] = filter[key].join('//')
                }
            }
        }

        if (selectedFilter.id === 'date' && p_.byStartDateChecked) {
            filter.startDate = moment(startDate).utc().format('YYYY-MM-DD HH:mm:ss')
        }
        if (selectedFilter.id === 'date' && p_.byEndDateChecked) {
            filter.endDate = moment(endDate).utc().format('YYYY-MM-DD HH:mm:ss')
        }

        closeFilter()

        if (p_.onFilterChange) {
            p_.onFilterChange(filter, true)
        }
    }

    return {
        openFilter,
        isFilterOpen,
        selectFilter,
        selectedFilter,
        _filterSearch,
        filterSearch,
        checkAll,
        filterFields,
        toggleField,
        startDate,
        endDate,
        closeFilter,
        onFilterChange,
        setStartDate,
        setEndDate,
        resetFilter,
        resetRequested,
    }
}

export default HistoryFilterMethods
